<!-- Hero Section -->
<div class="softwaredev-section-bg">
  <section class="softwaredev-section container py-5">
    <div class="glass-panel-container">
      <div class="row align-items-center">
        <div class="col-lg-5">
          <h1 class="softwaredev-heading mb-3">The Rise of AI Agents in Enterprise Automation</h1>
          <!-- <h3 class="softwaredev-subheading2 mb-4">Discover the fresh stories of Kalpita Technologies.</h3> -->
          <div class="mb-5 contact-btn"></div>
        </div>
        <div class="col-lg-7 text-center">
          <img src="../../../../assets/resources/whitepaper/rise-of-ai-agent/rise-of-ai-agents-bannerimg.gif"
            alt="Rise-of-AI-Agents" class="img-fluid hero-image">
        </div>
      </div>
    </div>
  </section>
</div>

<!-- TL;DR Section -->
<section class="takeaways-section py-5">
  <div class="container">
    <h2 class="section-title text-center">TL;DR</h2>
    <div class="takeaways-list">
      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
        <p><strong>AI agents surpass traditional automation</strong> by learning, planning, and adapting to
          complex, unstructured tasks across HR, IT, finance, marketing, and more.</p>
      </div>
      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
        <p><strong>Early adopters report tangible benefits</strong> faster processes, cost reductions,
          revenue growth, and improved customer experience.</p>
      </div>
      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
        <p><strong>Human + AI collaboration is key</strong> new roles like prompt engineers, agent
          orchestrators, and HITL specialists ensure agents augment, not replace, human work.</p>
      </div>
      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
        <p><strong>Governance, security, and staged adoption</strong> are critical to scale safely and unlock
          enterprise-wide efficiency and innovation.</p>
      </div>
      <!-- Add other items here -->
    </div>
  </div>
</section>

<!-- Key Takeaways Section -->
<section class="takeaways-section pt-0 pb-5">
  <div class="container">
    <h2 class="section-title text-center">Summary</h2>
    <div class="takeaways-list">
      <div class="takeaway-item">
        <p>AI agents are revolutionizing enterprise automation by moving beyond scripted workflows to autonomous,
          goal-driven collaboration across functions. Real-world case studies, from Verizon to Coca-Cola, show
          significant gains in productivity, cost savings, and revenue generation. Success requires a hybrid human–agent
          approach, addressing data, process, and governance challenges while creating new AI-centric roles. With
          strategic adoption, robust security, and workforce upskilling, enterprises can harness AI agents to streamline
          operations, innovate faster, and redefine the workforce, positioning themselves as leaders in the enterprise
          of 2025 and beyond.</p>
      </div>
      <!-- Add other items here -->
    </div>

    <!-- Button triggers Modal -->
    <button class="btn case-study-btn" (click)="openModal()">
      <i class="ri-download-2-line"></i> Download the Complete White Paper
    </button>
  </div>
</section>

<app-relevant-whitepaper></app-relevant-whitepaper>

<!-- MODAL POPUP -->
<div class="modal-overlay" *ngIf="isModalOpen">
  <div class="modal-content-box">
    <button class="close-btn" (click)="closeModal()">&times;</button>

    <div class="modal-header" *ngIf="!submitSuccess">
      <h3>Download White Paper</h3>
      <p>Fill in your details to receive the white paper.</p>
    </div>

    <div *ngIf="submitSuccess" class="success-message text-center">
      <i class="ri-checkbox-circle-fill" style="color: #28a745; font-size: 3rem;"></i>
      <h4>Thank you!</h4>
      <p>Check your email for the download link.</p>
      <small style="color: #666;">Please check your spam folder if you don't see it.</small>
    </div>

    <form [formGroup]="downloadForm" (ngSubmit)="onSubmit()" *ngIf="!submitSuccess">
      <div class="form-group">
        <label>Full Name</label>
        <input type="text" formControlName="name" class="form-control" placeholder="Name">
        <div class="error-msg" *ngIf="downloadForm.get('name')?.touched && downloadForm.get('name')?.errors">

          <span *ngIf="downloadForm.get('name')?.errors?.['required']">
            Name is required
          </span>

          <span *ngIf="downloadForm.get('name')?.errors?.['pattern']">
            Name should contain only letters
          </span>

        </div>
      </div>

      <div class="form-group">
        <label>Email Address</label>
        <input type="email" formControlName="email" class="form-control" placeholder="Email">
        <div class="error-msg" *ngIf="downloadForm.get('email')?.touched && downloadForm.get('email')?.errors">

          <span *ngIf="downloadForm.get('email')?.errors?.['required']">
            Email is required
          </span>

          <span *ngIf="downloadForm.get('email')?.errors?.['pattern']">
            Enter a valid email address
          </span>

        </div>
      </div>

      <div class="alert alert-danger" *ngIf="errorMessage">{{ errorMessage }}</div>

      <div class="modal-footer">
        <button type="submit" class="submit-btn" [disabled]="isSubmitting">
          {{ isSubmitting ? 'Processing...' : 'Download Now' }}
        </button>
      </div>
    </form>
  </div>
</div>